import React, { useEffect, useState } from 'react';
import { Trans as I18NextTrans } from 'react-i18next';
import { I18nWrapperProps } from '../interfaces';

// react-i18next >= 15 expects newer i18next types than the version used in this repo,
// which can make `Trans` lose its call signature in TS and break JSX typing.
// Runtime is fine; we cast to a JSX-compatible component type to unblock compilation.
const Trans = I18NextTrans as unknown as React.ComponentType<any>;

const transComponents = (imgSrc?: string[]) => {
  const source = imgSrc || '';
  const transImg: any = {};
  imgSrc?.forEach((src, index) => {
    const tagName = `img${index + 1}`;
    transImg[tagName] = <img src={src} alt="" />;
  });
  return {
    italic: <i />,
    bold: <strong />,
    span: <span />,
    small: <small />,
    h1: <h1 />,
    h2: <h2 />,
    h3: <h3 />,
    h4: <h4 />,
    h5: <h5 />,
    h6: <h6 />,
    br: <br />,
    article: <article />,
    section: <section />,
    img: <img src={source[0]} alt="" />,
    ...transImg,
    ul: <ul />,
    ol: <ol />,
    li: <li />,
    nbsp: <>&nbsp;</>,
  };
};
const I18nWrapper = ({
  translateKey,
  options,
  prefix,
  imgSrc,
}: I18nWrapperProps): React.JSX.Element => {
  const [pf, setPf] = useState<string>('');

  useEffect(() => {
    if (!prefix) return;
    setPf(`${prefix}.`);
  }, [prefix]);

  return (
    <Trans
      i18nKey={pf + translateKey}
      values={options}
      components={transComponents(imgSrc)}
      transSupportBasicHtmlNodes
    />
  );
};

export default I18nWrapper;
